import MobileChecker from './MobileChecker.js';
import SimpleParallax from "simple-parallax-js";
import {gsap} from "gsap";

class BaseHelpers {
  static html = document.documentElement;

  /**
   * Check browser support for .webp images
   * (i) required for proper display of webp images in CSS
   */
  static checkWebpSupport() {
    /** Check for webp support */
    const testWebp = (callback) => {
      const webP = new Image();

      webP.onload = webP.onerror = () => callback(webP.height === 2);
      webP.src =
        'data:image/webp;base64,UklGRjoAAABXRUJQVlA4IC4AAACyAgCdASoCAAIALmk0mk0iIiIiIgBoSygABc6WWgAA/veff/0PP8bA//LwYAAA';
    };

    /** Add class _webp or _no-webp to HTML */
    testWebp((support) => {
      const className = support ? 'webp' : 'no-webp';
      this.html.classList.add(className);

    });
  }

  /** Divides text for feature section */
  static splitText(element) {
    element.innerHTML = element.textContent
        .split('')
        .map((char) => `<span>${char}</span>`)
        .join('');
  }

  /** Show card on scroll */
  static showCardsSequentially(startIndex, lastIndex, cards) {
    for (let i = startIndex; i <= lastIndex + 1; i++) {
      if (cards[i]) {
        setTimeout(() => {
          cards[i].classList.add("active");
        }, (i + startIndex) * 100);
      }
    }
  }

  /** Hide card on scroll */
  static hideCardsSequentially(startIndex, lastIndex, cards) {
    for (let i = lastIndex; i >= startIndex; i--) {
      if (cards[i]) {
        setTimeout(() => {
          cards[i].classList.remove("active");
        }, (lastIndex - i) * 300);
      }
    }
  }

  /** Scroll to section */
  static scrollToSection(targetElement, position) {
    targetElement.scrollIntoView({
      block: position,
      inline: 'center',
      behavior: 'smooth'
    })
  }

  static removeClass(entity, classDeleted, selectorId) {
    let element = entity;
    let classDel = classDeleted;

    if (Array.isArray(entity))
      element = entity.find((link) => link.classList.contains(classDeleted));
    else classDel = `${classDeleted}-${selectorId}`;

    element.classList.remove(classDel);
  }

  static writeClass(entity, classWritten, classSearch) {
    let element = entity;
    let classLink = classWritten;

    if (Array.isArray(entity))
      element = entity.find(
          (link) => link.getAttribute("href").substring(1) === classSearch
      );
    else classLink = `${classWritten}-${classSearch}`;

    element.classList.add(classLink);
  }

  /**
   * Add touch class to HTML if the browser is mobile
   */
  static addTouchClass() {
    if (MobileChecker.isAny) {
      this.html.classList.add('touch');
    }
  }

  /**
   * Setting up current year
   */
  static setupCurrentYear(element) {
    element.textContent = new Date().getFullYear();
  }

  /**
   * Add loaded class to HTML after the page is fully loaded
   */
  static addLoadedClass() {
    window.addEventListener('load', () => {
      setTimeout(() => {
        this.html.classList.add('is-loaded');
      }, 10);
    });
  }

  /** Create parallax for images */
  static handleParallax(element, scale) {
    element.forEach((image) => {
      new SimpleParallax(image, {
        scale,
        delay: 0.6,
        orientation: "down",
      });
    });
  }

  /** Removes active class of phone constructor element */
  static removeActiveClass(elements) {
    elements.forEach((el) => {
      el.classList.remove("create__color-btn_active");
    })
  }

  /** Removes previous slider */
  static async removePrevSlider(swiper) {
    const previousIndex = swiper.activeIndex;
    const previousSlide = swiper.slides[previousIndex];
    previousSlide.classList.add("prev");

    await new Promise((resolve) => setTimeout(resolve, 150));

    swiper.slideNext();

    setTimeout(function () {
      previousSlide.classList.remove("prev");
    }, 400);
  }

  /** Slider image change */
  static changeSlider(elements, listener, swiper) {
    elements.forEach((picture) => {
      picture.addEventListener(listener, function (event) {
        const touchX = event.touches[0].clientX; // Get the x-coordinate of the touch
        const rect = picture.getBoundingClientRect(); // Get the dimensions of the image
        const imageCenter = rect.left + rect.width / 2; // Calculate the center of the image

        if (touchX < imageCenter) {
          // Тач по левой части картинки возврат к предыдущему слайду
          swiper.slidePrev();
        } else {
          // Тач по правой части картинки переход к следующему слайду
          BaseHelpers.removePrevSlider(swiper).then();
        }
      })
    })
  }

  /** Increase progress bar promo section */
  static increaseProgressBar(progressBg, progressCurrent) {
    const initialValue = 10;
    const finalValue = 60;

    gsap.to(progressBg, { height: "80%", duration: 6, ease: "none" });

    gsap.to(
        { value: initialValue },
        {
          value: finalValue,
          duration: 6,
          ease: "none",
          roundProps: { value: 10 },
          onUpdate: function () {
            progressCurrent.textContent = this.targets()[0].value;
          },
        }
    );
  }
}

export default BaseHelpers;